import React from "react";
import { motion } from "framer-motion";
import { Box, Typography, Grid, Stack, Chip, Tooltip } from "@mui/material";
import { useTheme, alpha } from "@mui/material/styles";
import { StepContainer, PlatformCard } from "../styles";
import { stepContent } from "../content";
import { ModernButton } from "../../styled/button";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

const cardVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.4 },
  },
};

const IntegrationsStep = ({ onNavigate, canNavigate = true }) => {
  const theme = useTheme();
  const content = stepContent.integrations;

  return (
    <StepContainer>
      {/* Header */}
      <Box sx={{ textAlign: "center", mb: 4 }}>
        <Typography variant="h4" fontWeight={700} gutterBottom>
          {content.title}
        </Typography>
        <Typography variant="body1" color="text.secondary">
          {content.subtitle}
        </Typography>
      </Box>

      {/* Platforms Grid */}
      <Grid container spacing={3} sx={{ mb: 4 }}>
        {content.platforms.map((platform, index) => (
          <Grid item xs={12} md={4} key={index}>
            <motion.div
              variants={cardVariants}
              initial="hidden"
              animate="visible"
              transition={{ delay: index * 0.15 }}
              whileHover={{ scale: 1.03 }}
            >
              <PlatformCard
                elevation={2}
                platformColor={theme.palette.primary.main}
              >
                <Typography variant="h6" fontWeight={600} gutterBottom>
                  {platform.name}
                </Typography>

                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ mb: 2 }}
                >
                  {platform.description}
                </Typography>

                {/* Feature Chips */}
                <Stack
                  direction="row"
                  spacing={0.5}
                  justifyContent="center"
                  sx={{ flexWrap: "wrap", gap: 0.5, mt: "auto" }}
                >
                  {platform.features.map((feature, idx) => (
                    <Chip
                      key={idx}
                      label={feature}
                      size="small"
                      sx={{
                        bgcolor: alpha(theme.palette.primary.main, 0.1),
                        color: "primary.main",
                        fontWeight: 500,
                        fontSize: "0.75rem",
                      }}
                    />
                  ))}
                </Stack>
              </PlatformCard>
            </motion.div>
          </Grid>
        ))}
      </Grid>

      {/* CTA */}
      <Box sx={{ display: "flex", justifyContent: "center", mt: "auto" }}>
        <Tooltip
          title={!canNavigate ? "Apenas administradores podem acessar esta configuracao" : ""}
          placement="top"
        >
          <span>
            <ModernButton
              onClick={() => onNavigate && onNavigate(content.ctaRoute)}
              endIcon={<ArrowForwardIcon />}
              size="large"
              disabled={!canNavigate}
            >
              {content.ctaLabel}
            </ModernButton>
          </span>
        </Tooltip>
      </Box>
    </StepContainer>
  );
};

export default IntegrationsStep;
